import { formatDate, formatMoney } from 'lib/functions/utils';

import { DocumentConciliationRateHistory } from './types';

export const getConciliationTypeLabel = (type: string): string => {
  const labels: Record<string, string> = {
    payIn: 'Recaudación',
    fund: 'Pago de fondo',
    quote: 'Aplicación en operación',
    credit: 'Aplicación en crédito',
    passive: 'Devolución de excedentes',
    creditNote: 'Nota de crédito',
    discount: 'Descuento',
  };
  return labels[type] || type;
};

export const formatConciliationsTable = (
  history: DocumentConciliationRateHistory,
) => {
  if (!history?.conciliations || history.conciliations.length === 0) {
    return [];
  }

  return history.conciliations.map((conciliation) => ({
    id: conciliation.id,
    Fecha: formatDate(new Date(conciliation.date), 'dd-mm-yyyy'),
    Tipo: getConciliationTypeLabel(conciliation.type),
    Monto: formatMoney(conciliation.amount),
    'Días desde pago': conciliation.daysSincePayment,
    'Tasa aplicada': `${conciliation.arrearRate}%`,
  }));
};

export const formatArrearTableSegments = (
  history: DocumentConciliationRateHistory,
) => {
  if (
    !history?.arrearTable?.segments ||
    history.arrearTable.segments.length === 0
  ) {
    return [];
  }

  return history.arrearTable.segments.map((segment) => ({
    id: segment.id,
    'Rango días': `${segment.min} - ${segment.max}`,
    'Tasa mensual': `${segment.value}%`,
    Tipo: segment.type,
    Subtipo: segment.subType,
  }));
};
